import {
  ZWSHelper
} from '@/native/ZWSHelper.js'
export const ForgetPasswordLogic = {
  /**
   * 恢复密码
   * @param {*} username 用户名
   * @param {*} type 选择方式 ,手机或者邮箱
   * @param {*} callback 回调
   */
  recoverPassword (username, type) {
    return new Promise((resolve, reject) => {
      ZWSHelper.recoverPassword({
        username: username,
        type: type
      }).then(res => {
        resolve(res.result)
      }).catch(error => {
        reject(error.result)
      })
    })
  },
  /**
   * 重置密码
   * @param {*} username 用户名
   * @param {*} password 密码
   * @param {*} code 验证码
   * @param {*} callback 回调
   */
  resetPassword (username, password, code) {
    return new Promise((resolve, reject) => {
      ZWSHelper.resetPassword({
        username: username,
        password: password,
        code: code
      }).then(res => {
        resolve(res.result)
      }).catch(error => {
        reject(error.result)
      })
    })
  },
  /**
   * 用户名是否存在
   * @param {*} data 用户名
   */
  isUsernameExist (username) {
    return new Promise((resolve, reject) => {
      ZWSHelper.isUsernameExist({
        username: username
      }).then(res => {
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./third_party/common_app/LoginModule/Logic/ForgetPasswordLogic.js